<!--
 * @Description: 找图片页面
 * @Author: trae.ai
 * @Date: 2024-11-05
-->
<template>
    <div class="findImage">
        <!-- Banner区域 -->
        <div v-if="banner && banner.length" class="findImage-banner">
            <img :src="img.logo" v-for="img in banner" :key="img.logo" alt="" @click="openBanner(img.url)" />
        </div>

        <div class="findImage-body">
            <!-- 分类选项卡 -->
            <div class="findImage-tabs">
                <el-tabs v-model="tabName" @tab-click="handleTabClick">
                    <el-tab-pane :label="item.name" v-for="item in tabList" :name="`${item.id}`" :key="item.id">
                        <svg-icon v-if="item.newStatus === 1" icon-class="new" class-name="icon-new-top"></svg-icon>

                        <!-- 二级分类选择 -->
                        <div
                            class="tab-item"
                            v-if="
                                item.childCategoryList &&
                                item.childCategoryList.length &&
                                String(item.id) === tabName &&
                                activeTab.categoryParentId != -1
                            "
                        >
                            分类：
                            <span
                                :class="{ active: activeTab.categoryId === subItem.id }"
                                @click="setCategory(subItem.id)"
                                v-for="subItem in item.childCategoryList"
                                :key="subItem.id"
                            >
                                <svg-icon v-if="subItem.newStatus === 1" icon-class="new" class-name="icon-new"></svg-icon>
                                {{ subItem.name }}
                            </span>
                        </div>

                        <!-- 格式选择 -->
                        <div class="tab-item" v-if="item.childFormatList && item.childFormatList.length && String(item.id) === tabName">
                            格式：
                            <span
                                :class="{ active: activeTab.formatId === subItem.id }"
                                @click="setFormat(subItem.id)"
                                v-for="subItem in item.childFormatList"
                                :key="subItem.id"
                            >
                                {{ subItem.name }}
                            </span>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>

            <!-- 筛选下拉选项 -->
            <el-dropdown trigger="hover" @command="(val) => handleDropdown('sort', val)" class="custom-dropdown sort-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.sort !== '1'}">
                <div class="el-dropdown-link">
                    <span>{{ getSortLabel(activeTab.sort) }}</span>
                    <i class="el-icon-error close-icon" v-show="activeTab.sort !== '1'" @click="clearFilter('sort', $event)"></i>
                    <i class="el-icon-arrow-down" v-show="activeTab.sort === '1'"></i>
                </div>
                <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown">
                    <!-- <el-dropdown-item command="1" :class="{'is-active': activeTab.sort === '1'}">默认排序</el-dropdown-item> -->
                    <el-dropdown-item command="2" :class="{'is-active': activeTab.sort === '2'}">最近更新</el-dropdown-item>
                    <el-dropdown-item command="5" :class="{'is-active': activeTab.sort === '5'}">免费素材</el-dropdown-item>
                    <el-dropdown-item command="6" :class="{'is-active': activeTab.sort === '6'}">付费素材</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            
            <el-dropdown trigger="hover" @command="(val) => handleDropdown('price', val)" class="custom-dropdown price-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.price !== ''}">
                <div class="el-dropdown-link">
                    <span>{{ getTwoSortLabel(activeTab.price) }}</span>
                    <i class="el-icon-error close-icon" v-show="activeTab.price !== ''" @click="clearFilter('price', $event)"></i>
                    <i class="el-icon-arrow-down" v-show="activeTab.price === ''"></i>
                </div>
                <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown">
                    <!-- <el-dropdown-item command="" :class="{'is-active': activeTab.price === ''}">价格排序</el-dropdown-item> -->
                    <el-dropdown-item command="2" :class="{'is-active': activeTab.price === '2'}">由低到高</el-dropdown-item>
                    <el-dropdown-item command="1" :class="{'is-active': activeTab.price === '1'}">由高到低</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown trigger="hover" @command="(val) => handleDropdown('size', val)" class="custom-dropdown size-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.size !== ''}">
                <div class="el-dropdown-link">
                    <span>{{ getSizeLabel(activeTab.size) }}</span>
                    <i class="el-icon-error close-icon" v-show="activeTab.size !== ''" @click="clearFilter('size', $event)"></i>
                    <i class="el-icon-arrow-down" v-show="activeTab.size === ''"></i>
                </div>
                <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown">
                    <!-- <el-dropdown-item command="" :class="{'is-active': activeTab.size === ''}">全部尺寸</el-dropdown-item> -->
                    <el-dropdown-item v-for="item in sizeList" :key="item" :command="item" :class="{'is-active': activeTab.size === item}">{{ item }}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown trigger="hover" @command="(val) => handleDropdown('proportion', val)" class="custom-dropdown price-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.proportion !== ''}">
                <div class="el-dropdown-link">
                    <span>{{ getProportionLabel(activeTab.proportion) }}</span>
                    <i class="el-icon-error close-icon" v-show="activeTab.proportion !== ''" @click="clearFilter('proportion', $event)"></i>
                    <i class="el-icon-arrow-down" v-show="activeTab.proportion === ''"></i>
                </div>
                <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown">
                    <!-- <el-dropdown-item command="" :class="{'is-active': activeTab.proportion === ''}">全部比例</el-dropdown-item> -->
                    <el-dropdown-item command="0" :class="{'is-active': activeTab.proportion === '0'}">横图</el-dropdown-item>
                    <el-dropdown-item command="1" :class="{'is-active': activeTab.proportion === '1'}">竖图</el-dropdown-item>
                    <el-dropdown-item command="2" :class="{'is-active': activeTab.proportion === '2'}">方图</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown trigger="hover" class="custom-dropdown price-dropdown" placement="bottom-start" :class="{'is-selected': activeTab.colorList && activeTab.colorList.length > 0}">
                <div class="el-dropdown-link color-dropdown">
                    <b><i class="color-icon" :class="{'white-color': selectedColor.color === '#FFFFFF'}" v-show="activeTab.colorList.length" :style="{ backgroundColor: selectedColor.color }"></i>{{ selectedColor.name }}</b>
                    <i class="el-icon-error close-icon" v-show="activeTab.colorList.length" @click="clearColor($event)"></i>
                    <i class="el-icon-arrow-down" v-show="!activeTab.colorList.length"></i>
                </div>
                <el-dropdown-menu slot="dropdown" popper-class="find-image-dropdown">
                    <div class="color-list">
                        <span class="color-item" @click="setColor(item.id)" :class="{'active': activeTab.colorList && activeTab.colorList.includes(item.id)}" v-for="item in colorList" :key="item.id">
                            <span class="color-item-color" :class="{'white-color': item.color === '#FFFFFF'}" :style="{ backgroundColor: item.color }"></span>
                        </span>
                    </div>
                </el-dropdown-menu>
            </el-dropdown>

            <!-- 图片列表 -->
            <find-image-list :tab="activeTab" materialType="1" />
        </div>
    </div>
</template>

<script>
import { getCategoryAndFormat, getColorList, getImageSizeList } from '@/api/findImage/index';
import { getBannerURL } from '@/api/common';
import FindImageList from './components/ImageList';
import Tabs from '@/components/Tabs';

export default {
    name: 'FindImage',
    components: {
        FindImageList,
        Tabs,
    },
    data: () => ({
        tabName: '',
        tabList: [],
        activeTab: {
            categoryParentId: sessionStorage.getItem('findImage_categoryParentIdTab')
                ? Number(sessionStorage.getItem('findImage_categoryParentIdTab'))
                : -1, // 一级分类ID
            categoryId: sessionStorage.getItem('findImage_categoryIdTab') ? Number(sessionStorage.getItem('findImage_categoryIdTab')) : -1, // 二级分类ID
            formatId: -1, // 格式ID始终初始化为-1
            sort: sessionStorage.getItem('findImage_sortTab') || '1', // 排序
            size: sessionStorage.getItem('findImage_sizeTab') || '', // 尺寸
            price: sessionStorage.getItem('findImage_twoSortTab') || '', // 价格排序
            proportion: sessionStorage.getItem('findImage_proportionTab') || '0', // 比例
            colorList: [] // 颜色列表
        },
        banner: '', // banner图地址
        sizeList: [],
        colorList: [],
    }),

    created() {
        // 从路由参数获取初始值并转换为数字
        const categoryParentId = this.$route.params.type ? Number(this.$route.params.type) : -1;
        const categoryId = this.$route.params.subType ? Number(this.$route.params.subType) : -1;
        const formatId = this.$route.params.format ? Number(this.$route.params.format) : -1;
        
        // 从URL查询参数获取排序值
        const sortFromQuery = this.$route.query.sort || sessionStorage.getItem('findImage_sortTab') || '1';

        // 设置初始值，使用对象替换确保响应式
        this.activeTab = {
            categoryParentId: categoryParentId,
            categoryId: categoryId,
            formatId: formatId, // 从路由读取格式ID
            sort: sortFromQuery, // 优先从URL查询参数获取排序值
            size: sessionStorage.getItem('findImage_sizeTab') || '',
            price: sessionStorage.getItem('findImage_twoSortTab') || '',
            proportion: sessionStorage.getItem('findImage_proportionTab') || '',
            colorList: sessionStorage.getItem('findImage_colorListTab') ? JSON.parse(sessionStorage.getItem('findImage_colorListTab')) : []
        };

        // 保存到sessionStorage
        this.saveTabState('categoryParentId', categoryParentId);
        this.saveTabState('categoryId', categoryId);
        this.saveTabState('formatId', formatId);
        this.saveTabState('sort', sortFromQuery);

        console.log('初始化activeTab:', this.activeTab);
    },

    computed: {
        selectedColor() {
            if (!this.activeTab.colorList || this.activeTab.colorList.length === 0) {
                return { name: '颜色', color: 'transparent' };
            }
            const found = this.colorList.find(item => this.activeTab.colorList.includes(item.id));
            return found || { name: '颜色', color: 'transparent' };
        }
    },

    mounted() {
        this.fetchCategoryData();
        this.fetchBannerData();
        this.fetchSizeData();
        this.fetchColorData();

        // 在组件挂载后，确保tabName与activeTab.categoryParentId一致
        this.$nextTick(() => {
            this.updateTabName();
        });
    },

    watch: {
        // 监听路由变化
        $route(to, from) {

            console.log('路由变化: ', to, from);
            if(to.name !== 'FindImage') {
                return;
            }
            // 从路由参数获取分类ID并转换为数字
            const categoryParentId = to.params.type ? Number(to.params.type) : -1;
            const categoryId = to.params.subType ? Number(to.params.subType) : -1;
            const formatId = to.params.format ? Number(to.params.format) : -1;
            
            // 从URL查询参数获取排序值
            const sortFromQuery = to.query.sort || this.activeTab.sort;

            // 保留当前的筛选状态
            const {size, price, proportion, colorList} = this.activeTab;

            // 更新组件状态，使用对象替换确保响应式
            this.activeTab = {
                categoryParentId: categoryParentId,
                categoryId: categoryId,
                formatId: formatId,
                sort: sortFromQuery, // 使用从URL查询参数获取的排序值
                size,
                price,
                proportion,
                colorList
            };

            // 更新tabName
            this.updateTabName();

            // 保存到sessionStorage
            this.saveTabState('categoryParentId', categoryParentId);
            this.saveTabState('categoryId', categoryId);
            this.saveTabState('formatId', formatId);
            this.saveTabState('sort', sortFromQuery);

            console.log('路由变化更新activeTab:', this.activeTab);
        },
    },

    methods: {
        // 更新tabName，确保与activeTab.categoryParentId一致
        updateTabName() {
            console.log('更新tabName, 当前activeTab:', this.activeTab, '当前tabList:', this.tabList);

            if (this.activeTab.categoryParentId !== -1) {
                // 如果有有效的一级分类ID，直接使用
                this.tabName = String(this.activeTab.categoryParentId);
                console.log('使用activeTab.categoryParentId更新tabName:', this.tabName);
            } else if (this.tabList && this.tabList.length > 0) {
                // 保存当前状态
                const { formatId, sort, size, price, proportion, colorList } = this.activeTab;
                
                // 如果一级分类为-1，但有可用的分类列表，则选中第一个
                const firstCategoryId = this.tabList[0].id;
                this.tabName = String(firstCategoryId);
                console.log('使用第一个分类更新tabName:', this.tabName);

                // 同时更新activeTab，但保留当前所有筛选状态
                this.activeTab = {
                    categoryParentId: Number(firstCategoryId),
                    categoryId: -1,
                    formatId, // 保留当前格式ID
                    sort,
                    size, 
                    price,
                    proportion,
                    colorList
                };

                // 保存到sessionStorage
                this.saveTabState('categoryParentId', firstCategoryId);

                // 更新路由，保留格式ID和查询参数
                const formatPath = formatId !== -1 ? `/${formatId}` : '';
                const query = { ...this.$route.query }; // 保留当前的查询参数
                if (this.$route.params.type !== String(firstCategoryId)) {
                    this.$router.replace({ 
                        path: `/findImage/${firstCategoryId}/-1${formatPath}`,
                        query 
                    });
                }

                console.log('使用第一个分类更新activeTab:', this.activeTab);
            } else {
                // 如果没有可用的分类列表，则设置为空字符串
                this.tabName = '';
                console.log('没有可用分类，设置tabName为空');
            }
        },

        // 处理tab点击事件
        handleTabClick(tab) {
            this.setTabPane(tab.name);
        },

        // 设置一级分类（点击tab时）
        setTabPane(id) {
            console.log('设置一级分类id: ', id);
            // 确保id是数字类型
            const categoryParentId = Number(id);

            // 更新路由，不重置格式ID和查询参数
            const formatPath = this.activeTab.formatId !== -1 ? `/${this.activeTab.formatId}` : '';
            const query = { ...this.$route.query }; // 保留当前的查询参数
            this.$router.replace({ 
                path: `/findImage/${categoryParentId}/-1${formatPath}`,
                query
            });

            // 保留当前的筛选状态
            const {sort, size, price, proportion, colorList} = this.activeTab;

            // 通过替换整个对象来确保响应式更新
            this.activeTab = {
                categoryParentId: categoryParentId,
                categoryId: -1,
                formatId: this.activeTab.formatId, // 保留当前的格式ID
                sort,
                size,
                price,
                proportion,
                colorList
            };

            // 更新tabName
            this.tabName = String(categoryParentId);

            // 保存到sessionStorage
            this.saveTabState('categoryParentId', categoryParentId);
            this.saveTabState('categoryId', -1);
            // 不重置formatId的本地存储
            
            console.log('设置一级分类后的activeTab:', this.activeTab);
        },

        // 设置二级分类
        setCategory(id) {
            console.log('设置二级分类id: ', id);
            // 确保id是数字类型
            const categoryId = Number(id);
            
            // 保留当前格式参数和查询参数
            const formatPath = this.activeTab.formatId !== -1 ? `/${this.activeTab.formatId}` : '';
            const query = { ...this.$route.query }; // 保留当前的查询参数
            
            // 更新路由，保留当前格式ID和查询参数
            this.$router.replace({ 
                path: `/findImage/${this.activeTab.categoryParentId}/${categoryId}${formatPath}`, 
                query 
            });

            // 通过替换整个对象来确保响应式更新
            this.activeTab = {
                ...this.activeTab,
                categoryId: categoryId,
            };

            // 保存到sessionStorage
            this.saveTabState('categoryId', categoryId);
        },

        // 设置格式ID
        setFormat(id) {
            console.log('设置格式id: ', id);
            // 确保id是数字类型
            const formatId = Number(id);

            // 构建URL路径，处理二级分类参数，保留查询参数
            const categoryId = this.activeTab.categoryId;
            const query = { ...this.$route.query }; // 保留当前的查询参数
            
            // 更新路由，始终保持二级分类ID在URL中，并保留查询参数
            const formatPath = formatId !== -1 ? `/${formatId}` : '';
            this.$router.replace({ 
                path: `/findImage/${this.activeTab.categoryParentId}/${categoryId}${formatPath}`, 
                query 
            });

            // 通过替换整个对象来确保响应式更新，保留当前的二级分类ID
            this.activeTab = {
                ...this.activeTab,
                formatId: formatId,
            };

            // 保存到sessionStorage
            this.saveTabState('formatId', formatId);
        },

        // 打开banner链接
        openBanner(imgUrl) {
            window.open(imgUrl);
        },

        // 获取分类和格式数据
        async fetchCategoryData() {
            try {
                const { data } = await getCategoryAndFormat();
                this.tabList = data || [];

                // 确保一级分类ID有效
                if (this.activeTab.categoryParentId === -1 || !this.tabList.some((item) => item.id == this.activeTab.categoryParentId)) {
                    // 如果一级分类ID无效，则使用第一个分类的ID
                    if (this.tabList.length > 0) {
                        const firstCategoryId = Number(this.tabList[0].id);
                        // 保存当前格式ID和筛选状态
                        const { formatId, sort, size, price, proportion, colorList } = this.activeTab;
                        
                        // 使用对象替换确保响应式
                        this.activeTab = {
                            categoryParentId: firstCategoryId,
                            categoryId: -1,
                            formatId, // 保留当前的格式ID
                            sort,
                            size,
                            price,
                            proportion,
                            colorList
                        };
                        this.tabName = String(firstCategoryId);
                        this.saveTabState('categoryParentId', firstCategoryId);

                        // 更新路由，保留格式ID和查询参数
                        const formatPath = formatId !== -1 ? `/${formatId}` : '';
                        const query = { ...this.$route.query }; // 保留当前的查询参数
                        if (this.$route.params.type !== String(firstCategoryId)) {
                            this.$router.replace({ 
                                path: `/findImage/${firstCategoryId}/-1${formatPath}`,
                                query 
                            });
                        }

                        console.log('使用第一个分类更新activeTab:', this.activeTab);
                    }
                } else {
                    // 确保选中的tab与路由参数一致
                    this.tabName = String(this.activeTab.categoryParentId);
                }

                // 确保二级分类ID有效
                const currentCategory = this.tabList.find((item) => item.id == this.activeTab.categoryParentId);
                if (currentCategory && currentCategory.childCategoryList) {
                    const validSubCategory = currentCategory.childCategoryList.some((item) => item.id == this.activeTab.categoryId);

                    if (!validSubCategory && this.activeTab.categoryId !== -1) {
                        // 保存当前格式ID和筛选状态
                        const { formatId, sort, size, price, proportion, colorList } = this.activeTab;
                        
                        // 如果二级分类ID无效，则重置为-1，使用对象替换确保响应式
                        this.activeTab = {
                            ...this.activeTab,
                            categoryId: -1,
                            formatId, // 保留当前格式ID
                            sort,
                            size,
                            price,
                            proportion,
                            colorList
                        };
                        this.saveTabState('categoryId', -1);
                        
                        // 更新路由，保留格式ID和查询参数
                        const formatPath = formatId !== -1 ? `/${formatId}` : '';
                        const query = { ...this.$route.query }; // 保留当前的查询参数
                        this.$router.replace({ 
                            path: `/findImage/${this.activeTab.categoryParentId}/-1${formatPath}`,
                            query 
                        });

                        console.log('重置无效二级分类后的activeTab:', this.activeTab);
                    }
                }
            } catch (error) {
                console.log('获取分类数据失败: ', error);
            }
        },

        // 获取banner图地址
        async fetchBannerData() {
            try {
                const { data } = await getBannerURL(5);
                this.banner = (data || []).splice(0, 2);
            } catch (error) {
                console.log('获取banner数据失败: ', error);
            }
        },

        // 获取尺寸数据
        async fetchSizeData() {
            try {
                const { data } = await getImageSizeList();
                this.sizeList = data || [];
                console.log('获取尺寸数据成功:', this.sizeList);
            } catch (error) {
                console.log('获取尺寸数据失败: ', error);
                // 设置默认尺寸数据作为备选
                this.sizeList = [
                    { id: '1', name: '16:9', size: '16:9' },
                    { id: '2', name: '4:3', size: '4:3' },
                    { id: '3', name: '1:1', size: '1:1' },
                    { id: '4', name: '9:16', size: '9:16' },
                    { id: '5', name: '3:4', size: '3:4' }
                ];
            }
        },

        // 获取颜色数据
        async fetchColorData() {
            try {
                const { data } = await getColorList();
                this.colorList = data || [];
                console.log('获取颜色数据成功:', this.colorList);
            } catch (error) {
                console.log('获取颜色数据失败:', error);
                // 设置默认颜色数据作为备选
                this.colorList = [
                    { id: '1', name: '红色', color: '#EE4A4A' },
                    { id: '2', name: '蓝色', color: '#0E6BF6' },
                    { id: '3', name: '橙色', color: '#FD8616' },
                    { id: '4', name: '紫色', color: '#7E03F9' },
                    { id: '5', name: '黄色', color: '#FFEB3B' },
                    { id: '6', name: '黑色', color: '#000000' },
                    { id: '7', name: '绿色', color: '#029E78' },
                    { id: '8', name: '白色', color: '#FFFFFF' },
                    { id: '9', name: '青色', color: '#0AF4FC' },
                    { id: '11', name: '灰色', color: '#888888' }
                ];
            }
        },

        // 保存筛选状态到sessionStorage
        saveTabState(type, value) {
            sessionStorage.setItem(`findImage_${type}Tab`, value);
            sessionStorage.setItem(this.$route.path, 1);
        },

        // 处理颜色选择
        setColor(id) {
            console.log('设置颜色筛选条件:', id);
            // 保存旧值用于比较
            const oldColorList = [...this.activeTab.colorList];
            
            // 设置为单选模式
            this.activeTab.colorList = [id];
            
            // 保存颜色选择状态
            this.saveTabState('colorList', JSON.stringify(this.activeTab.colorList));
            
            // 比较新旧值，如果不同则强制刷新组件
            if (JSON.stringify(oldColorList) !== JSON.stringify(this.activeTab.colorList)) {
                // 克隆当前的activeTab对象
                const tempTab = { ...this.activeTab };
                
                // 先将activeTab设置为空对象，触发ImageList重新渲染
                this.activeTab = {};
                
                // 在下一个事件循环中恢复正确的值
                this.$nextTick(() => {
                    this.activeTab = tempTab;
                });
            }
        },

        // 清除颜色选择
        clearColor(event) {
            // 阻止事件冒泡，避免触发下拉菜单
            if (event) {
                event.stopPropagation();
            }
            
            console.log('清除颜色筛选条件');
            // 保存旧值用于比较
            const oldColorList = [...this.activeTab.colorList];
            
            // 清空颜色列表
            this.activeTab.colorList = [];
            
            // 保存颜色选择状态
            this.saveTabState('colorList', JSON.stringify(this.activeTab.colorList));
            
            // 比较新旧值，如果不同则强制刷新组件
            if (oldColorList.length > 0) {
                // 克隆当前的activeTab对象
                const tempTab = { ...this.activeTab };
                
                // 先将activeTab设置为空对象，触发ImageList重新渲染
                this.activeTab = {};
                
                // 在下一个事件循环中恢复正确的值
                this.$nextTick(() => {
                    this.activeTab = tempTab;
                });
            }
        },

        // 处理下拉菜单选择
        handleDropdown(type, val) {
            console.log(`设置${type}筛选条件:`, val);
            // 保存旧值用于比较
            const oldValue = this.activeTab[type];
            
            // 更新筛选值
            this.activeTab[type] = val;
            
            // 保存到sessionStorage
            this.saveTabState(type, val);
            
            // 如果是排序条件，将其添加到URL查询参数中
            if (type === 'sort') {
                // 保留当前的路径参数，只修改查询参数
                const currentPath = this.$route.path;
                const query = { ...this.$route.query, sort: val };
                
                // 更新路由，不触发导航守卫
                this.$router.replace({ path: currentPath, query });
            }
            
            // 比较新旧值，如果不同则强制刷新组件，确保ImageList感知到变化
            if (oldValue !== val) {
                // 克隆当前的activeTab对象
                const tempTab = { ...this.activeTab };
                
                // 先将activeTab设置为空对象，触发ImageList重新渲染
                this.activeTab = {};
                
                // 在下一个事件循环中恢复正确的值
                this.$nextTick(() => {
                    this.activeTab = tempTab;
                });
            }
        },

        // 获取排序标签
        getSortLabel(val) {
            const map = {
                '1': '排序',
                '2': '最近更新',
                '5': '免费素材',
                '6': '付费素材'
            };
            if (val === '1') return '排序';
            return map[val] || '排序';
        },

        // 获取尺寸标签
        getSizeLabel(val) {
            if (!val) return '尺寸';
            const item = this.sizeList.find(item => item === val);
            return item || '尺寸';
        },

        // 获取比例标签
        getProportionLabel(val) {
            const map = {
                '': '比例',
                '0': '横图',
                '1': '竖图',
                '2': '方图',
            };
            if (val === '') return '比例';
            return map[val] || '比例';
        },

        // 获取价格排序标签
        getTwoSortLabel(val) {
            const map = {
                '': '价格',
                '1': '由高到低',
                '2': '由低到高'
            };
            if (val === '') return '价格';
            return map[val] || '价格';
        },

        // 添加clearFilter方法
        clearFilter(type, event) {
            // 阻止事件冒泡
            if (event) {
                event.stopPropagation();
            }
            
            console.log(`清除${type}筛选条件`);
            
            // 获取默认值
            const defaultValues = {
                sort: '1',
                size: '',
                price: '',
                proportion: ''
            };
            
            // 保存旧值用于比较
            const oldValue = this.activeTab[type];
            
            // 重置为默认值
            this.activeTab[type] = defaultValues[type];
            
            // 保存到sessionStorage
            this.saveTabState(type, defaultValues[type]);
            
            // 如果是排序条件，将其添加到URL查询参数中
            if (type === 'sort') {
                // 保留当前的路径参数，只修改查询参数
                const currentPath = this.$route.path;
                const query = { ...this.$route.query };
                
                // 如果是默认排序，从查询参数中移除
                if (defaultValues[type] === '1') {
                    delete query.sort;
                } else {
                    query.sort = defaultValues[type];
                }
                
                // 更新路由，不触发导航守卫
                this.$router.replace({ path: currentPath, query });
            }
            
            // 比较新旧值，如果不同则强制刷新组件
            if (oldValue !== defaultValues[type]) {
                // 克隆当前的activeTab对象
                const tempTab = { ...this.activeTab };
                
                // 先将activeTab设置为空对象，触发ImageList重新渲染
                this.activeTab = {};
                
                // 在下一个事件循环中恢复正确的值
                this.$nextTick(() => {
                    this.activeTab = tempTab;
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.findImage {
    &-banner {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        img {
            width: 790px;
            height: 200px;
            border-radius: 8px;
            cursor: pointer;
        }
    }

    &-body {
        padding: 0 20px;
    }

    &-tabs {
        margin-bottom: 20px;

        :deep(.el-tabs__nav-wrap::after) {
            height: 1px;
        }

        :deep(.el-tabs__active-bar) {
            height: 3px;
        }

        :deep(.el-tabs__item) {
            font-size: 16px;
            color: #272c40;
            &.is-active {
                color:#2C54EF;
                font-weight: 600;
            }
            &:hover {
                color:#2C54EF;
            }
        }
    }
}

.tab-item {
    margin-bottom: 9px;
        color:#a4a7b4;
        font-size: 16px;
        span {
            margin-right: 20px;
            padding: 3px 8px;
            display: inline-block;
            color: #272c40;
            font-size: 16px;
            cursor: pointer;
            position: relative;
            &:hover {
                color: #2c54ef;
            }
            &.active {
                color: #2F54EB;
                background: #DCE3FD;
                border-radius: 4px;
            }
            .icon-new {
                position: absolute;
                right: 0px;
                top: -10px;
            }
        }
}

.icon-new-top {
    position: absolute;
    top: 0;
    right: -15px;
    font-size: 30px;
}

.icon-new {
    position: absolute;
    top: -5px;
    right: -15px;
    font-size: 20px;
}

/* 自定义下拉菜单样式 */
.custom-dropdown {
    display: inline-block;
    font-size: 14px;
    background: #f5f6f9;
    border-radius: 4px;
    padding: 0 10px;
    height: 32px;
    line-height: 32px;
    cursor: pointer;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    // margin-right: 10px;
    vertical-align: middle;
    position: relative;
    text-align: left;
    
    &.sort-dropdown {
        width: 104px;
    }
    
    &.size-dropdown {
        width: 104px;
        margin-left: 20px;
    }
    
    &.price-dropdown {
        width: 104px;
        margin-left: 20px;
    }
    .close-icon {
        color: rgb(186, 186, 203);
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 16px;
        cursor: pointer;
        
        &:hover {
            color: #939880;
        }
    }
    .color-icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        border-radius: 100%;
        margin-right: 5px;
        &.white-color {
            border: 1px solid #DADADA;
        }
    }
    
    .el-dropdown-link {
        color: #606266;
        display: flex;
        align-items: center;
        font-size: 14px;
        position: relative;
        
        span, b {
            display: block;
            width: calc(100% - 15px);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 5px;
        }
        
        &:hover {
            color: #2C54EF;
        }
        
        .el-icon-arrow-down {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            font-size: 12px;
            color: #C0C4CC;
        }
    }
    .color-dropdown {
        height: 32px;
        b {
            display: inline-flex;
            align-items: center;
        }
    }
    
    &:hover, &.is-selected {
        border-color: #2C54EF;
        
        .el-icon-arrow-down {
            color: #2C54EF;
        }
        
        .el-dropdown-link {
            color: #2C54EF;
        }
    }
}
</style>

<style lang="scss">
/* 全局样式，确保下拉菜单样式应用 */
.el-dropdown-menu[popper-class="find-image-dropdown"] {
    padding: 8px 5px !important;
    border: 1px solid #E4E7ED !important;
    border-radius: 4px !important;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
    min-width: 104px !important;
    
    .el-dropdown-menu__item {
        padding: 0 5px !important;
        font-size: 14px !important;
        height: 34px !important;
        line-height: 34px !important;
        border-radius: 4px !important;
        margin: 3px 0 !important; /* 增加上下间距 */
        
        &:hover {
            color: #606266 !important;
            background-color: #F5F7FA !important; /* 浅灰色背景 */
        }
        
        &.is-active {
            color: #2F54EB !important;
            background-color: #EAEEFD !important; /* 当前选中蓝色背景 */
            font-weight: 500 !important;
        }
        
        &.is-disabled {
            color: #c0c4cc !important;
        }
    }
    .color-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width:104px;
        padding: 7px;
    }
    .color-item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 34px;
        height: 34px;
        border-radius: 100%;
        margin-bottom: 12px;
        border: 1px solid #ffffff;
        &:nth-child(2n) {
            margin-right: 0;
        }
        &:nth-last-child(1) {
            margin-bottom: 0;
        }
        &:nth-last-child(2) {
            margin-bottom: 0;
        }
        cursor: pointer;
        &.active {
            border: 1px solid #2F54EB;
        }
        .color-item-color {
            box-sizing: border-box;
            width: 26px;
            height: 26px;
            border-radius: 100%;
        }
        .white-color {
            border: 1px solid #DADADA;
        }
    }
}

.sort-dropdown .el-dropdown-menu[popper-class="find-image-dropdown"] {
    min-width: 110px !important;
}

.size-dropdown .el-dropdown-menu[popper-class="find-image-dropdown"],
.price-dropdown .el-dropdown-menu[popper-class="find-image-dropdown"] {
    min-width: 140px !important;
}
</style>
